import { useIsAuthenticated } from '@azure/msal-react'
import { AppButton } from '@components/AppButton'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@components/ui/dropdown-menu.tsx'
import AuthenticatedInfo from '@layouts/RoleBasedLayout/components/AuthenticatedInfo.tsx'
import { LoginButton } from '@layouts/RoleBasedLayout/components/LoginButton.tsx'
import { TenantMenuItems } from '@layouts/RoleBasedLayout/components/TenantMenuItems.tsx'
import { User } from 'lucide-react'
import { useTenant } from '@/contexts/TenantContext'

export function ProfileButton() {
  const isAuthenticated = useIsAuthenticated()
  const { currentTenant } = useTenant()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="ml-auto flex flex-row gap-2 items-center  rounded-full hover:bg-viken-rock-200 hover:border-input pl-4 pr-0 pb-0 pt-0 cursor-pointer">
          <div className="text-sm font-medium">{currentTenant.displayName}</div>
          <AppButton variant="outline" role="combobox" className=" w-9 rounded-[50%] ml-auto ">
            <User size={16} strokeWidth={1.25} absoluteStrokeWidth />
          </AppButton>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent sideOffset={10} side="bottom" align="end" className="p-2">
        {isAuthenticated && (
          <>
            <AuthenticatedInfo />
            <TenantMenuItems />
          </>
        )}
        <DropdownMenuGroup>
          <DropdownMenuItem className="focus:bg-white px-1">
            <LoginButton />
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
